<template>
  <v-care-plan-template
    :carePlan="carePlan"
    :careplanIntervention="careplanIntervention"
    :careplanAssessment="careplanAssessment"
    :careplanInstruction="careplanInstruction"
  >
    <div
      slot="action"
      class="text-right mt-2"
    >
      <b-button
        variant="primary"
        :disabled="loading"
        @click="cloneCarePlan()"
      >
        Clone
      </b-button>
    </div>
  </v-care-plan-template>
</template>

<script>
import VCarePlanTemplate from '@/components/careplan/View.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import modules from '../_modules';

export default {
  name: 'ViewCareplan',
  components: { VCarePlanTemplate },

  data() {
    return {
      modules,
      id: ''
    };
  },
  computed: {
    ...mapGetters({
      loading: 'careplan/getLoading',
      careplanTemplate: 'careplan/getCareplanTemplate'
    }),
    carePlan() {
      const template = this.careplanTemplate;
      // eslint-disable-next-line camelcase
      const { plan_start_date, plan_end_date } = template;
      // eslint-disable-next-line camelcase
      template.plan_start_date = plan_start_date || new Date();
      // eslint-disable-next-line camelcase
      template.plan_end_date = plan_end_date || moment(new Date()).add(1, 'years');
      return template;
    },
    careplanIntervention() {
      return {
        index: 1,
        name: 'Prescriptions',
        module: modules.intervene,
        isEdit: false,
        list: this.careplanTemplate.interventionTemplate
      };
    },
    careplanAssessment() {
      return {
        index: 2,
        name: 'Side Effects/Symptoms',
        module: modules.assessment,
        isEdit: false,
        list: this.careplanTemplate.assessmentTemplate
      };
    },
    careplanInstruction() {
      return {
        index: 3,
        name: 'Note Instruction',
        module: modules.instruction,
        isEdit: false,
        list: this.careplanTemplate.instructionTemplate
      };
    }
  },
  beforeMount() {
    this.$store.dispatch('careplan/getTemplate', this.$route.params.id);
  },
  methods: {
    cloneCarePlan() {
      const { id } = this.$route.params;
      this.$store.dispatch('careplan/createCarePlan', id);
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
